import http from "@http"

//列表  不分页
export function getComponentAll(data) {
    return http({
        url: '/lskj-data/api/data/component/all',
        method: "post",
        data
    })
}
//列表  分页
export function getComponentList(data) {
    return http({
        url: '/lskj-data/api/data/component/list',
        method: "post",
        data
    })
}

//查询单条
export function componentById(data) {
    return http({
        url: `/lskj-data/api/data/component/byId?id=${data.id}`,
        method: "get",
    })
}

//添加
export function componentAdd(data) {
    return http({
        url: '/lskj-data/api/data/component/add',
        method: "post",
        data
    })
}

//修改
export function updeteComponent(data) {
    return http({
        url: `/lskj-data/api/data/component`,
        method: "put",
        data
    })
}
//删除
export function deleteComponent(data) {
    return http({
        url: `/lskj-data/api/data/component?ids=${data.ids}`,
        method: "delete",
        data
    })
}